import { createAsyncThunk } from '@reduxjs/toolkit';

const getWorkSpaceUsers = async (
  { searchTerm },
  { extra: { http } },
  state
) => {
  try {
    if (searchTerm && searchTerm.length > 1) {
      const data = await http.get(
        `/search/workspace_users?q=${searchTerm}&ext_type=google`
      );
      return data;
    }

    const data = await http.get('/search/workspace_users?ext_type=google');
    return data;
  } catch (e) {
    return { error: e.message || 'Failed to fetch users' };
  }
};

const postBulkInviteWorkSpaceUsers = async (
  { payload },
  { extra: { http } },
  state
) => {
  try {
    const data = await http.post(`/account_invitations/bulk`, {
      account_invitations: payload,
    });
    return data;
  } catch (e) {}
};

const postAtsBulkInviteWorkSpaceUsers = async (
  { payload },
  { extra: { http } },
  state
) => {
  try {
    const data = await http.post(`/account/users/bulk`, {
      users: payload,
    });
    return data;
  } catch (e) {
    return { error: e.message || 'Failed to invite users' };
  }
};

export const fetchWorkspaceUsersList = createAsyncThunk(
  'workspaceUsers/list',
  getWorkSpaceUsers
);

export const fetchATtsWorkspaceUsersList = createAsyncThunk(
  'workspaceUsers/list',
  getWorkSpaceUsers
);

export const bulkInviteWorkspaceUsers = createAsyncThunk(
  'workspaceUsers/bulkInvite',
  postBulkInviteWorkSpaceUsers
);

export const atsBulkInviteWorkspaceUsers = createAsyncThunk(
  'workspaceUsers/bulkInvite',
  postAtsBulkInviteWorkSpaceUsers
);
